    angular.module('aprima-core').constant('MedicationHistoryFilterSubtype', {
        Default: 0,
        Rx: 1        
    });

